import { useTranslate } from '@growtherapy/i18n';
import { Body, Button } from '@growtherapy/sprout-ui';

export function FocusOfLastSessionContent({
  hasNotes,
  focusText,
  onClick,
}: {
  hasNotes: boolean;
  focusText?: string;
  onClick: () => void;
}): JSX.Element {
  const t = useTranslate();

  if (!hasNotes) {
    return (
      <Button use='link' onClick={onClick}>
        {t('telehealth-core:providerIntersessionSummary.viewPreviousNotes')}
      </Button>
    );
  }

  return (
    <div className='flex flex-col rebrand:gap-350'>
      <Body.Default>{focusText}</Body.Default>
      <Button use='link' onClick={onClick}>
        {t('telehealth-core:providerIntersessionSummary.viewNote')}
      </Button>
    </div>
  );
}
